// file: addressTile.jsx
import React, { useEffect, useState } from "react";
import styles from "./addressTile.module.scss";
import { connect, useDispatch } from "react-redux";
import {
  getCustomerById,
  getCustomerTotalOrdersQuantity,
  getReceipt,
  schedulePickup,
  updateOrderStatusByCartBundleId,
} from "../../../store/actions";
import { getObjectFromArrayOfObjects } from "../../../utils/common/CommonFunctions";
import CustomButton from "../../customComponents/customButton/CustomButton";
import {
  Box,
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { DateRange, UploadFile } from "@mui/icons-material";
import DoneIcon from "@mui/icons-material/Done";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { useNavigate } from "react-router-dom";
const AddressTile = ({
  cartBundleData = {},
  cartBundleId,
  customer,
  customerTotalOrders,
  states,
  status,
  shipment,
}) => {
  const dispatch = useDispatch();
  const [pickupShow, setPickupShow] = useState(false);
  const [pickupDate, setPickupDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [pickupCompleted, setPickupCompleted] = useState(false);
  const [dateRange, setDateRange] = useState({ minDate: "", maxDate: "" });
  const [isDownloadingReceipt, setIsDownloadingReceipt] = useState(false);

  const navigate = useNavigate();

  const addressData = cartBundleData?.address;

  console.log("cartBundleData", cartBundleData);
  console.log("addressData", addressData);
  useEffect(() => {
    dispatch(
      getCustomerById({
        id: cartBundleData?.customer,
        callback: {
          success: (data) => console.log(data, "addressDatafromSaga"),
        },
      })
    );
    dispatch(
      getCustomerTotalOrdersQuantity({
        id: cartBundleData?.customer,
        callback: {
          success: (data) => console.log(data, "addressDatafromSaga"),
        },
      })
    );
  }, []);

  const getReceiptFileName = (pkg = {}) => {
    const identifier = pkg?.wbn || shipment?.awb || cartBundleId || "receipt";
    return `receipt-${identifier}.pdf`;
  };

  const openPdfInNewTab = (url) => {
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (!win && typeof window !== "undefined") {
      window.location.href = url;
    }
  };

  const downloadBlob = (blob, fileName) => {
    if (window.navigator?.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName);
      return;
    }
    const link = document.createElement("a");
    const canDownloadAttr = typeof link.download !== "undefined";
    if (canDownloadAttr) {
      const blobUrl = window.URL.createObjectURL(blob);
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
      return;
    }
    // Fallback for browsers (iOS Safari, some Android WebViews) where the download attribute is ignored.
    const reader = new FileReader();
    reader.onloadend = () => openPdfInNewTab(reader.result);
    reader.readAsDataURL(blob);
  };

  const downloadFromBase64 = (base64String, fileName) => {
    if (!base64String) return;
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i += 1) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    downloadBlob(blob, fileName);
  };

  const triggerReceiptDownload = async (pkg = {}) => {
    const pdfUrl = pkg?.pdf_download_link;
    const pdfEncoding = pkg?.pdf_encoding;
    const fileName = getReceiptFileName(pkg);
    if (pdfUrl) {
      const response = await fetch(pdfUrl);
      if (!response.ok) {
        throw new Error("Unable to fetch receipt PDF");
      }
      const blob = await response.blob();
      downloadBlob(blob, fileName);
      return;
    }

    if (pdfEncoding) {
      downloadFromBase64(pdfEncoding, fileName);
      return;
    }

    throw new Error("Receipt unavailable – missing PDF data");
  };

  console.log("addressData", addressData);

  // dispatch(getCustomerById({ id: item?.customerId }));

  const handlePickup = () => {
    setIsLoading(true);
    dispatch(
      schedulePickup({
        expected_package_count: 1,
        pickup_date: pickupDate,
        cartBundleId: cartBundleId,
        callback: {
          success: () =>
            dispatch(
              updateOrderStatusByCartBundleId({
                id: cartBundleId,
                status: 2,
                callback: {
                  success: (data) => {
                    setPickupCompleted(true);
                    setIsLoading(false);
                    // navigate(-1);
                  },
                },
              })
            ),
          failure: () => setIsLoading(false),
        },
      })
    );
  };

  useEffect(() => {
    const today = new Date();

    const formatDate = (date) =>
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date.getDate()).padStart(2, "0")}`;

    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const nextWeek = new Date(today);
    nextWeek.setDate(today.getDate() + 7);

    setDateRange({
      minDate: formatDate(tomorrow),
      maxDate: formatDate(nextWeek),
    });
  }, []);

  const handleDownload = () => {
    if (!shipment?.awb) return;
    setIsDownloadingReceipt(true);
    dispatch(
      getReceipt({
        waybillNumber: shipment?.awb,
        callback: {
          success: async (data) => {
            try {
              const pkg = data?.packages?.[0];
              if (!pkg) throw new Error("Receipt unavailable");
              await triggerReceiptDownload(pkg);
            } catch (error) {
              console.error("Receipt download failed", error);
              const fallbackPkg = data?.packages?.[0];
              if (fallbackPkg?.pdf_download_link) {
                try {
                  openPdfInNewTab(fallbackPkg.pdf_download_link);
                } catch (fallbackError) {
                  console.error(
                    "Unable to open receipt fallback",
                    fallbackError
                  );
                }
              } else if (fallbackPkg?.pdf_encoding) {
                openPdfInNewTab(
                  `data:application/pdf;base64,${fallbackPkg.pdf_encoding}`
                );
              }
            } finally {
              setIsDownloadingReceipt(false);
            }
          },
          failure: () => setIsDownloadingReceipt(false),
        },
      })
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>Customer</h3>
          <div className={styles.customerInfo}>
            <div className={styles.avatar}>
              {customer?.fullName ? customer?.fullName[0] : "NA"}
            </div>
            <div className={styles.customerDetails}>
              <h4 className={styles.customerName}>{customer?.fullName}</h4>
              <p className={styles.orders}>
                {customerTotalOrders?.totalOrderQuantity} Orders
              </p>
            </div>
          </div>

          <div className={styles.contactInfo}>
            <div className={styles.contactRow}>
              <span className={styles.icon}>
                <EmailOutlinedIcon />
              </span>
              <span className={styles.email}>{cartBundleData?.email}</span>
            </div>
            <div className={styles.contactRow}>
              <span className={styles.icon}>
                <LocalPhoneIcon />
              </span>
              <a href="tel:+919876567898" className={styles.phone}>
                {addressData?.phoneNumber}
              </a>
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>Shipping Address</h3>
          <p className={styles.addressLine}>{addressData?.addressLine1}</p>
          <p className={styles.addressLine}>{addressData?.addressLine2}</p>
          <p className={styles.addressLine}>
            {addressData?.city} {addressData?.postalCode}
          </p>
          <p className={styles.addressLine}>
            {
              getObjectFromArrayOfObjects(states, "id", addressData?.state)
                ?.name
            }
          </p>
          <p className={styles.addressLine}>{addressData?.country} </p>
        </div>
        {status === 1 && (
          <div className={styles?.pickupWrapper}>
            {!pickupShow && (
              <CustomButton
                title={"Schedule Pickup"}
                txtClr={"#FFFFFF"}
                background={"hsla(187, 98%, 16%, 1)"}
                width={"100%"}
                height={"34px"}
                borderRadius={"12px"}
                onClick={() => setPickupShow(true)}
              />
            )}

            {pickupShow && (
              <div className={styles?.inputWrapper}>
                <FormControl
                  variant="outlined"
                  // focused={true}
                  classes={{ root: styles.inputContainer }}
                  fullWidth
                >
                  <InputLabel id={`label-date`}>Choose Date</InputLabel>

                  <OutlinedInput
                    id="outline-input-date"
                    type="date"
                    classes={{
                      root: styles.input,
                      input: styles.inputField,
                    }}
                    label="Choose Date"
                    value={pickupDate || ""} // ✅ Ensures empty on load
                    onChange={(e) => setPickupDate(e.target.value)}
                    startAdornment={
                      <DateRange style={{ marginRight: "8px" }} />
                    }
                    inputProps={{
                      // min: dateRange?.minDate,
                      max: dateRange?.maxDate,
                    }}
                  />
                </FormControl>

                {isLoading ? (
                  <div className={styles?.progress}>
                    <CircularProgress size={25} style={{ color: "#014751" }} />
                    Pickup in progress
                  </div>
                ) : (
                  <>
                    {pickupCompleted ? (
                      <div>
                        <DoneIcon />
                        Pickup Scheduled
                      </div>
                    ) : (
                      // <CustomButton
                      //   startIcon={<DoneIcon />}
                      //   title={"Pickup completed"}
                      //   txtClr={"#FFFFFF"}
                      //   background={"hsla(187, 98%, 16%, 1)"}
                      //   width={"100%"}
                      //   height={"34px"}
                      //   borderRadius={"12px"}
                      // />
                      <CustomButton
                        title={"Confirm"}
                        txtClr={"#FFFFFF"}
                        background={
                          !pickupDate ? "gray" : "hsla(187, 98%, 16%, 1)"
                        }
                        width={"100%"}
                        height={"34px"}
                        borderRadius={"12px"}
                        disabled={!pickupDate}
                        onClick={() => handlePickup()}
                      />
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        )}
        {status === 2 && (
          <div  className={styles.progress} style={{}}>
            <DoneIcon />
            Pickup Scheduled
          </div>
          // <CustomButton
          //   startIcon={<DoneIcon />}
          //   title={"Pickup completed"}
          //   txtClr={"#FFFFFF"}
          //   background={"hsla(187, 98%, 16%, 1)"}
          //   width={"100%"}
          //   height={"34px"}
          //   borderRadius={"12px"}
          // />
        )}
      </div>

      {status >= 1 && (
        <div className={styles.wrapper}>
          <div className={styles.section}>
            <CustomButton
              title={
                isDownloadingReceipt
                  ? "Preparing receipt..."
                  : "Download Receipt"
              }
              txtClr={"#FFFFFF"}
              background={"hsla(187, 98%, 16%, 1)"}
              width={"100%"}
              height={"34px"}
              borderRadius={"12px"}
              disabled={isDownloadingReceipt}
              onClick={() => handleDownload()}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    customer: state?.customer?.customer,
    customerTotalOrders: state?.orders?.customerTotalOrders,
    states: state?.state?.states,
    shipment: state.delhivery?.shipment,
  };
};
export default connect(mapStateToProps, null)(AddressTile);
